import { FadeIn } from "./FadeIn";
import { SCOPE } from "@/content";

export const Scope = () => (
  <section id="scope" data-testid="scope-section" className="border-y border-[#D8D4CA] bg-[#EFECE6] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto max-w-5xl">
      <FadeIn>
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.3em] text-[#D18237]">{SCOPE.overline}</p>
        <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-[#0A0F16] md:text-5xl">{SCOPE.title}</h2>
      </FadeIn>
      <div className="mt-16">
        {SCOPE.items.map((item, i) => (
          <FadeIn key={i} delay={i * 0.05}>
            <div data-testid={`scope-row-${i}`} className="grid gap-3 border-t border-[#D8D4CA] py-8 transition-colors duration-500 hover:bg-white/40 md:grid-cols-[280px_1fr] md:gap-12">
              <div className="flex items-start gap-4">
                <span className="font-serif text-xl text-[#D18237]">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-serif text-xl leading-snug text-[#122336] md:text-2xl">{item.area}</h3>
              </div>
              <p className="text-sm leading-[1.9] text-[#4A525B] md:text-base">{item.body}</p>
            </div>
          </FadeIn>
        ))}
        <div className="border-t border-[#D8D4CA]" />
      </div>
    </div>
  </section>
);
